import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToString',
  standalone: true
})
export class NumberToStringPipe implements PipeTransform {
  private readonly suffixes = {
    short: ['', 'K', 'M', 'B', 'T'],
    long: ['', 'Thousand', 'Million', 'Billion', 'Trillion']
  };

  transform(value: number, unit: string = "Units", useShortForm: boolean = true, fractionDigits: number = 0): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }

    const absValue = Math.abs(value);
    const suffixIndex = Math.floor(Math.log10(absValue) / 3);
    const roundedValue = this.roundNumber(absValue / Math.pow(1000, suffixIndex), fractionDigits);
    const suffixForm = useShortForm ? this.suffixes.short : this.suffixes.long;
    const suffix = suffixForm[suffixIndex] || '';

    return `${value < 0 ? '-' : ''}${roundedValue} ${suffix} ${unit}`;
  }

  private roundNumber(value: number, fractionDigits: number): number {
    const factor = Math.pow(10, fractionDigits);
    return Math.round(value * factor) / factor;
  }
}